import { render, staticRenderFns } from "./UKHomeTop10SwiperSlide.vue?vue&type=template&id=1699138e&scoped=true"
import script from "./UKHomeTop10SwiperSlide.vue?vue&type=script&setup=true&lang=ts"
export * from "./UKHomeTop10SwiperSlide.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UKHomeTop10SwiperSlide.vue?vue&type=style&index=0&id=1699138e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1699138e",
  null
  
)

export default component.exports